import React from "react";

/**
 * Fallback für React.Suspense (Code-Splitting, i18n-Ladevorgang).
 */
function PageLoader() {
  return (
    <div
      className="flex min-h-[50vh] items-center justify-center bg-slate-50 dark:bg-slate-900"
      role="status"
      aria-live="polite"
      aria-label="Loading"
    >
      <div className="h-10 w-10 animate-spin rounded-full border-2 border-primary border-t-transparent dark:border-primary-light dark:border-t-transparent" />
    </div>
  );
}

export default PageLoader;
